<template>
	<DiscoveryTableSingleComponents
		v-if="Object.keys(singleDiscovery).length"
		:edit-mode="true"
		:single-discovery="singleDiscovery"
	/>
	<PreloaderComponent v-else/>
</template>

<script>
import SolFileAPIInstance from '@/api'
import PreloaderComponent from '@/components/common/PreloaderComponent'
import DiscoveryTableSingleComponents from './DiscoveryTableSingleComponents/DiscoveryTableSingleComponents'

export default {
	name: "DiscoveryTableSingleEdit",
	components: {
		DiscoveryTableSingleComponents,
		PreloaderComponent
	},
	data() {
		return {
			singleDiscovery: {}
		}
	},
	async mounted() {
		const {id} = this.$route.params
		const item = await SolFileAPIInstance.getDiscoveryById(id)
		if (item.data) {
			this.singleDiscovery = item.data
		}
	}
}
</script>
